import React from 'react';

import statuses from 'data/last_member_program_statuses';

import Icon from './Icon';
import User from './User';

const columns = [
  {
    name: 'Member',
    selector: 'attributes.student_full_name',
    sortable: true,
    cell: (row) => (
      <User
        name={row.attributes.student_full_name}
        session_room_id={row.attributes.session_room_id}
      />
    ),
  },
  {
    name: 'Coach',
    selector: 'attributes.coach_full_name',
    sortable: true,
    cell: (row) => (
      <User
        name={row.attributes.coach_full_name}
        session_room_id={row.attributes.session_room_id}
      />
    ),
  },
  {
    name: 'Match',
    selector: 'attributes.coach_match',
    sortable: true,
    width: '70px',
  },
  {
    name: 'Started On',
    selector: 'attributes.created_date_formatted',
    sortable: true,
  },
  {
    name: 'Status',
    selector: 'attributes.status',
    sortable: true,
    cell: (row) => statuses.find((item) => item.value === row.attributes.status)?.label,
    width: '100px',
  },
  {
    name: 'Rate',
    selector: 'attributes.coach_rate',
    sortable: true,
    width: '60px',
  },
  {
    name: 'Feedback',
    selector: 'attributes.rate',
    cell: (row) => <Icon rate={row.attributes.rate} />,
    width: '80px',
  },
];

export default columns;
